import { useState, useEffect } from "react";
import { fetchAuthSession } from "aws-amplify/auth";

const SUPER_ADMINS_GROUP = "SuperAdmins";

export function useSuperAdmin() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);

  useEffect(() => {
    const checkSuperAdmin = async () => {
      try {
        const session = await fetchAuthSession();
        const groups =
          (session.tokens?.accessToken?.payload?.["cognito:groups"] as string[]) || [];
        setIsSuperAdmin(groups.includes(SUPER_ADMINS_GROUP));
        setCurrentUserId(session.userSub ?? null);
      } catch {
        setIsSuperAdmin(false);
        setCurrentUserId(null);
      } finally {
        setIsChecking(false);
      }
    };

    checkSuperAdmin();
  }, []);

  return { isSuperAdmin, isChecking, currentUserId };
}
